import { ReportSummaryItemApi } from "../api/Reports";
import { useLocation, useNavigate } from "react-router-dom";

const useNavigateWithState = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navigateWithState = (reportUUID: string, page: string) => {
    let state: { originUrl: string; report?: ReportSummaryItemApi } = {
      originUrl: `${location.pathname}${location.search}`,
    };

    navigate(`/reports/${reportUUID}/${page}`, {
      state,
    });
  };
  return { navigateWithState };
};

export default useNavigateWithState;
